import React from 'react';
import { Phone, MapPin, MessageCircle, Instagram, Facebook } from 'lucide-react';
import { followInternalLink } from '../../lib/navigation';
import { brand, navLinks } from '../../mock';
import { WHATSAPP_NUMBER } from '../../lib/whatsapp';

// Office address verified 2026-10-16: https://www.remaxcorner.com.tr/ofisimiz
const officeAddress = 'Boğazkent Mahallesi, Atatürk Caddesi No: 61/B, Summer Garden Sitesi, Kepez / Merkez / Çanakkale';
const socialLinks = [
  { label: 'WhatsApp', href: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Merhaba, Çanakkale Konut Rehberi üzerinden iletişime geçmek istiyorum.')}`, Icon: MessageCircle },
  { label: 'Instagram', href: 'https://www.instagram.com/canakkalekonutrehberi/', Icon: Instagram },
  { label: 'Facebook', href: 'https://www.facebook.com/p/Kutay-%C3%96zt%C3%BCrk-61561196368618/', Icon: Facebook },
];

export default function Footer({ compact = false }) {
  const handleNav = (e, href) => {
    followInternalLink(e, href);
  };
  if (compact) return <footer className="ckr-compact-footer">
    <span>© {new Date().getFullYear()} {brand.name}</span>
    <a href="/iletisim/" onClick={e => followInternalLink(e, '/iletisim/')}>İletişim</a>
    <a href="/kvkk/">KVKK Aydınlatma Metni</a>
  </footer>;
  return (
    <footer id="iletisim" style={{ background: 'var(--ckr-petrol-deep)', color: 'rgba(240,234,221,0.82)' }}>
      <div className="ckr-container" style={{ paddingTop: 64, paddingBottom: 32 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 230px), 1fr))', gap: 'var(--ckr-grid-gap, 40px)' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <span style={{ width: 40, height: 40, borderRadius: 10, background: 'var(--ckr-gold)', color: '#241c0a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Fraunces, serif', fontWeight: 600 }}>ÇKR</span>
              <span style={{ fontFamily: 'Fraunces, serif', fontSize: 18, fontWeight: 600, color: '#f6f2e8' }}>{brand.name}</span>
            </div>
            <p style={{ fontSize: 14.5, maxWidth: 300, margin: 0 }}>{brand.tagline}</p>
            <div className="ckr-footer-address">
              <MapPin size={17} aria-hidden="true" />
              <div><span className="ckr-footer-address-label">RE/MAX Corner · Ofis Adresi</span><address>{officeAddress}</address></div>
            </div>
          </div>

          <div>
            <h4 style={{ color: '#f6f2e8', fontSize: 15, fontWeight: 600, marginTop: 0, marginBottom: 16 }}>Menü</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={(e) => handleNav(e, l.href)} style={{ color: 'rgba(240,234,221,0.8)', textDecoration: 'none', fontSize: 14, transition: 'color .2s ease' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--ckr-gold-soft)')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(240,234,221,0.8)')}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 style={{ color: '#f6f2e8', fontSize: 15, fontWeight: 600, marginTop: 0, marginBottom: 16 }}>İletişim</h4>
            <p className="ckr-footer-role">REMAX CORNER / Gayrimenkul Danışmanı</p>
            <p className="ckr-footer-name">{brand.person}</p>
            <a className="ckr-footer-phone" href={`tel:+${WHATSAPP_NUMBER}`}><Phone size={16} aria-hidden="true" />0530 978 19 17</a>
            <div className="ckr-footer-socials" aria-label="Sosyal medya ve mesajlaşma">
              {socialLinks.map(({label,href,Icon},index)=><a key={label} className={`ckr-footer-social${index===0?' is-primary':''}`} href={href} target="_blank" rel="noopener noreferrer" aria-label={label==='WhatsApp'?'WhatsApp ile iletişime geç':`${label} sayfam`}><Icon size={15} aria-hidden="true"/><span>{label}</span></a>)}
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(245,241,232,0.14)', marginTop: 44, paddingTop: 22, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12, fontSize: 13, color: 'rgba(240,234,221,0.6)' }}>
          <span>© {new Date().getFullYear()} {brand.name} · {brand.person}</span>
          <a href="/kvkk/" style={{ color: 'inherit', textUnderlineOffset: 3 }}>KVKK Aydınlatma Metni</a>
          <span>Melis, ÇKR\'nin dijital yardımcı asistanıdır.</span>
        </div>
      </div>
    </footer>
  );
}
